import {useVuelidate} from '@vuelidate/core';

export default function registerVuelidate(app) {
  app.config.globalProperties.$vuelidate = useVuelidate;
}
